// 资产申请

const onAssetApplyDlg = {
  namespaced: true,

  state: {
    dlgShow: false,
  },

  getters: {
    dlgShow: state => state.dlgShow,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },
  },

  actions: {

  }
}

export default onAssetApplyDlg
